'use strict';

//création de l'objet
angular.module('formonlineApp').factory('Bareme', ['$resource',
    function ($resource) {
        var Bareme = $resource('api/bareme/:id', {id: '@id'}, {
            'update': {method: 'PUT'}
        });

        Bareme.prototype.update = function (cb, ecb) {
            return Bareme.update({id: this.id},
                angular.extend({}, this, {id: undefined}), cb, ecb);
        };

        return Bareme;
    }]);


//liste des services
angular.module('formonlineApp').service('BaremeService',
    function (Bareme, $http, Language) {
        // Service methods...
        this.get = function (idStr) {
            return Bareme.get({
                id: idStr,
                locale: Language.current()
            }).$promise;
        };

        this.getCodeLRByAnnFis = function (annFis) {
            return $http({
                method: 'get',
                url: 'api/bareme/annee/' + annFis + '/lr'
            });
        };

        this.getCodeSansRevenuDeterminantByAnnee = function (annFis) {
            return $http({
                method: 'get',
                url: 'api/bareme/annee/' + annFis + '/sansrevenudeterminant'
            });
        };

        this.getCodeEnfantObligatoireByAnnee = function (annFis) {
            return $http({
                method: 'get',
                url: 'api/bareme/annee/' + annFis + '/enfantobligatoire'
            });
        };

        this.getCodeAvecEnfantsByAnnee = function (annFis) {
            return $http({
                method: 'get',
                url: 'api/bareme/annee/' + annFis + '/avecenfants'
            });
        };

        this.getCodeCalculetteByAnnee = function (annFis) {
            return $http({
                method: 'get',
                url: 'api/bareme/annee/' + annFis + '/calculette'
            });
        };

        this.getCodeCalculetteSansRevenuDeterminantByAnnee = function (annFis) {
            return $http({
                method: 'get',
                url: 'api/bareme/annee/' + annFis + '/calculettesansrevenudeterminant'
            });
        };

        this.getCodeCalculetteEnfantObligatoireByAnnee = function (annFis) {
            return $http({
                method: 'get',
                url: 'api/bareme/annee/' + annFis + '/calculetteenfantobligatoire'
            });
        };

        this.getCodeCalculetteAvecEnfantsByAnnee = function (annFis) {
            return $http({
                method: 'get',
                url: 'api/bareme/annee/' + annFis + '/calculetteavecenfants'
            });
        };

        this.getCodeFormulaireByAnnee = function (annFis) {
            return $http({
                method: 'get',
                url: 'api/bareme/annee/' + annFis + '/formulaire'
            });
        };

        this.list = function () {
            return $http({
                method: 'get',
                url: 'api/bareme/'
            });
        };

        this.getVariante = function (annee, baremeCode, revenu, etatCivil) {
            return $http({
                method: 'get',
                url: 'api/bareme/annee/' + annee + '/code/' + baremeCode + '/variante',
                params: {revenu: revenu, etatCivil: etatCivil}
            });
        };

        this.calculerCote = function (contexteFiscal, dateDebut, dateFin, baremeCode, nbEnfants, revenuBrut, travailDiscontinu, tauxActivite,
                                      tauxAutresActivites, nbHeuresTravail, revenuDeterminant) {
            var data = {
                contexteFiscal: {annee: contexteFiscal.annee},
                dateDebut: dateDebut,
                dateFin: dateFin,
                typeBareme: baremeCode,
                nbEnfants: nbEnfants,
                revenu: revenuBrut,
                impotParoisse: true,
                tauxActivite: tauxActivite ? tauxActivite : 1,
                tauxAutresActivites: tauxAutresActivites ? tauxAutresActivites : 0,
                extrapolerSurTauxActivite: true,
                travailDiscontinu: travailDiscontinu,
                nbHeuresTravail: nbHeuresTravail,
                revenuDeterminant: revenuDeterminant
            };
            return $http({
                method: 'post',
                url: 'api/bareme/cote',
                data: data
            });
        };

        this.calculerCoteByNbJours = function (nbJours, contexteFiscal, baremeCode, nbEnfants, revenuBrut, revenuConjoint,
                                               tauxActivite, tauxAutresActivites,
                                               travailDiscontinu, nbHeuresTravail,
                                               retenue, commission, revenuDeterminant, dossierTauxCommission, etatCivil, nbPersonnes) {
            var data = {
                nbJours: nbJours,
                nbEnfants: nbEnfants,
                revenu: revenuBrut,
                revenuConjoint: revenuConjoint,
                tauxActivite: tauxActivite,
                tauxAutresActivites: tauxAutresActivites,
                extrapolerSurTauxActivite: true,
                travailDiscontinu: travailDiscontinu,
                nbHeuresTravail: nbHeuresTravail,
                nbJoursTravail: null,
                retenue: null,
                commission: commission,
                contexteFiscal: {annee: contexteFiscal.annee},
                revenuDeterminant: revenuDeterminant,
                dossierTauxCommission: dossierTauxCommission,
                etatCivil: etatCivil,
                typeBareme: baremeCode,
                nbPersonnes: nbPersonnes,
                impotParoisse: true
            };
            return $http({
                method: 'post',
                url: 'api/bareme/cote',
                data: data
            });
        };

        this.calculerNbJours = function (dateDebut, dateFin) {
            return $http({
                method: 'post',
                url: 'api/bareme/datediff',
                params: {dateDebut: dateDebut, dateFin: dateFin}
            });
        };

        this.calculerDeduction = function (anneeFiscale, baremeCode, revenu, fraisDeduits) {
            return $http({
                method: 'post',
                url: 'api/bareme/deductionForfaitaire',
                params: {anneeFiscale: anneeFiscale, typeBareme: baremeCode, revenu: revenu, fraisDeduits: fraisDeduits}
            });
        };
    });
